import axios from "axios";
import { API_BASE_URL } from "../../../constants/apiConstants";

export const getDoctorState = (payload) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_BASE_URL}Medicos/ConsultaEstado`, payload, {
        headers: {
          Accept: "text/plain",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.data.statusResult === 200) {
          resolve(res.data.result);
        } else {
          reject(res.data.errors);
        }
      })
      .catch((err) => {
        reject(err.response ? err.response.data : "NO EXISTE EL MÉDICO");
      });
  });
};
